<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-11-17 16:10:55
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-02 14:32:06
-->
<template>
  <div>
    <el-form
      :model="collectForm"
      ref="collectForm"
      label-width="100px"
      class="demo-ruleForm"
      :style="{height:height}"
    >
      <el-form-item label="机器人名称">
        <el-input
          v-model="collectForm.robotName"
          placeholder="请输入机器人名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="问候语">
        <el-input
          placeholder="请输入问候语"
          v-model="collectForm.robotGreetings"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="无匹配答案">
        <el-input
          placeholder="请输入无匹配答案"
          v-model="collectForm.robotUndermatchingAnswer"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="机器人头像">
        <a-upload
          name="avatar"
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :before-upload="beforeUpload"
        >
          <img
            style="width: 100%; height: 100%"
            v-if="imageUrl"
            :src="imgIp + imageUrl"
            alt="avatar"
          />
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传图片</div>
          </div>
        </a-upload>
      </el-form-item>
      <el-form-item label="用户头像">
        <a-upload
          name="avatar"
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :before-upload="beforeUploadUser"
        >
          <img
            style="width: 100%; height: 100%"
            v-if="imageUrlUser"
            :src="imgIp + imageUrlUser"
            alt="avatar"
          />
          <div v-else>
            <a-icon :type="loadingTwo ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传图片</div>
          </div>
        </a-upload>
         <div style="font-size: 12px; margin-top: 0px">
              支持5MB以内的jpg、png图片
        </div>
      </el-form-item>
      <el-form-item label="服务评价">
        <div class="status">
          <el-radio v-model="collectForm.serviceEvaluation" :label="1">开启</el-radio>
          <el-radio v-model="collectForm.serviceEvaluation" :label="0">关闭</el-radio>
        </div>
        <div style="font-size: 12px">
           开启后,每成功回答一个用户问题都会显示评价选项
        </div>
      </el-form-item>
      <el-form-item label="用户满意提示">
        <el-input
          placeholder="感谢您的评价，我会努力学习做的更好"
          v-model="collectForm.userSatisfactionHint"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="不满意提示">
        <el-input
          placeholder="请输入不满意提示"
          v-model="collectForm.userUnsatisfiedHint"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <div class="form-bottom">
          <el-button
            :loading="loadingSubmint"
            @click="saveCollect"
             v-if="codeData.indexOf('288') != -1"
            size="medium"
            type="primary"
            >保存</el-button
          >
        </div>
  </div>
</template>
<script>
import { uploadImg } from "@/utils/common.js";
import {saveOrUpdateRobot,delDes} from '../../index'
import { message } from 'ant-design-vue';
export default {
  data() {
    return {
      collectForm: {},
      loadingSubmint: false,
      imageUrl: "",
      imageUrlUser: "",
      loading: false,
      loadingTwo:false,
      height:0,
      codeData:[],
      
    };
  },
  mounted(){
    this.getDel();
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
     this.height = (document.documentElement.clientHeight - 330) + 'px';
    window.onresize = () => {
      return (() => {
        this.height = (document.documentElement.clientHeight - 330) + 'px';
      })();
    };
  },
  methods: {
    getDel(){
        delDes({
            id:Number(sessionStorage.getItem('siteId'))
        }).then((res)=>{
            this.collectForm = res.data || {};
            this.imageUrl = res.data.robotHeadPortrait;
            this.imageUrlUser = res.data.userHeadPortrait;
        })
    },
    saveCollect(){
        saveOrUpdateRobot({
            siteId:sessionStorage.getItem('siteId'),
            ...this.collectForm,
            userHeadPortrait:this.imageUrlUser,
            robotHeadPortrait:this.imageUrl,
        }).then((res)=>{
                if(res.code == 0){
                        message.success('保存成功')
                }
        })
    },
    async beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
      }
      this.loading = true;
      let imgData = await uploadImg(file, "column_management");
      this.imageUrl = imgData.path;
      this.loading = false;
      return false;
    },
     async beforeUploadUser(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
      }
      this.loadingTwo = true;
      let imgData = await uploadImg(file, "column_management");
      this.imageUrlUser = imgData.path;
      this.loadingTwo = false;
      return false;
    },
  },
};
</script>

<style lang="less" scoped>
.demo-ruleForm {
  width: 600px;
  padding: 24px;
  padding-left: 24px;
  overflow-y: auto;
}
.form-bottom{
  width: 600px;
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 50px;
  padding:12px 24px;
  .btn{
     background: #1890ff;
      width: 96px;
       height: 34px;
       display: flex;
       align-items: center;
  }
}
.el-button--primary {
  background: #176de6;
}
</style>